import type { ReactNode } from 'react';

import styles from './states.module.css';

/** Every screen needs an empty state, not a blank page (skill 42). */
export function EmptyState({
  icon,
  title,
  message,
  children,
}: {
  icon: string;
  title: string;
  message: string;
  children?: ReactNode;
}) {
  return (
    <div className={styles.state}>
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      <p className={styles.title}>{title}</p>
      <p className={styles.message}>{message}</p>
      {children}
    </div>
  );
}
